export interface HelpDeskSubmission {
  FullName: string;
  Email: string;
  Phone: string;
  Body: string;
  SmartlookURL?: string;
  RelativeURL: string;
  ErrorHistory: string[];
  Image?: File;
  ShortDescription: string;
  SupportInfo: string;
}
